module.exports = __webpack_public_path__ + "img/icon-meat-dark-grey.a39453e8.svg";